
import { computed, defineComponent, ref, reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import CloserController from '@/components/molecules/CloserController.vue'
import AppButton from '../atoms/AppButton.vue'
import AppIconPlaces from '../atoms/AppIconPlaces.vue'
import AppInput from '../atoms/AppInput.vue'
import AppCheckbox from '../atoms/AppCheckbox.vue'
import AppLabelPlaces from '../atoms/AppLabelPlaces.vue'
import AppTagAddition from '../atoms/AppTagAddition.vue'
import DssIcon from '../atoms/DssIcon.vue'
import PlaceholderImage from '../atoms/PlaceholderImage.vue'
import ButtonIcon from '../molecules/ButtonIcon.vue'
import ModalWindow from '../organisms/ModalWindow.vue'
import CollectionDropdown from './TheMyCollectionCollectionDropdown.vue'
import AppTag from './TheMyCollectionAppTag.vue'
import TheMyCollectionItemsImage from './TheMyCollectionItemsImage.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'MyCollectionItemListView',
  components: {
    AppButton,
    AppCheckbox,
    AppLabelPlaces,
    AppIconPlaces,
    AppInput,
    AppTag,
    AppTagAddition,
    ButtonIcon,
    CloserController,
    CollectionDropdown,
    DssIcon,
    PlaceholderImage,
    ModalWindow,
    TheMyCollectionItemsImage,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isItem: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    },
    index: {
      type: Number,
      default: 0
    },
    displayMode: {
      type: String,
      default: 'list'
    },
    contentListViewHandler: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const BASE_URL = process.env.VUE_APP_CONTENTS_BASE_URL

    const i18n = useI18n()
    const store = useStore()
    const route = useRoute()
    const places = [
      { icon: '', text: '' },
      { icon: 'internet', text: i18n.t('permissionText.internet', { newLine: '<br>' }) },
      { icon: 'ooc', text: i18n.t('permissionText.ooc.isntLoggedIn', { newLine: '<br>' }) },
      { icon: 'inlibrary', text: i18n.t('permissionText.inlibrary', { newLine: '<br>' }) }
    ]

    const state = reactive({
      showContents: true,
    })

    const hasThumbnail = ref<boolean>(true)
    const notThumbnail = () => {
      hasThumbnail.value = false
    }

    const bookmarkItem = (query: any) => {
      store.dispatch('myCollectionAddRemoveList', query)
    }

    const tagList = computed(() => {
      return store.state.myCollectionInfo.tagList
    })

    const displayTagList = computed(() => {
      const TAG_ID_ALL = '0'
      const list = props.item.tagIds
      const filter = list.filter((v:number) => {
        return String(v) !== TAG_ID_ALL
      })

      return filter.length ? filter : false
    })

    const contentList = computed(() => {
      const contents = props.item.contents || []
      return contents.length ? contents : []
    })

    const contentsName = (name: any) => {
      if (!name) return ''
      return name.ja || ''
    }

    const onUnlink = (tagId: number) => {
      store.dispatch('myCollectionItemUnlink', {
        tagId: tagId,
        pid: props.item.pid,
      })
    }

    const permissionColor = computed(() => {
      if (!props.item.permission) return ''
      return props.item.permission.type
    })

    const permissionText = computed(() => {
      if (!props.item.permission) return ''
      const type: string = props.item.permission.type

      const INTERNET = 'internet'
      const OOC = 'ooc'
      const IN_LIBRARY = 'inlibrary'

      if (type === INTERNET) {
        return i18n.t('permissionText.internet', { newLine: '\r\n' })
      } else if (type === OOC) {
        return i18n.t('permissionText.ooc', { newLine: '\r\n' })
      } else if (type === IN_LIBRARY) {
        return i18n.t('permissionText.inlibrary', { newLine: '\r\n' })
      } else {
        return ''
      }
    })

    const contentListViewHandler = computed(() => props.contentListViewHandler)
    watch(contentListViewHandler, (is) => {
      state.showContents = is
    })

    const thumbnailLink = (item: any) => {
      const VIEW_TYPE_LIST_ITEM = 'list'
      if (VIEW_TYPE_LIST_ITEM === props.displayMode) return `/pid/${item.pid}`
      if (item.isItem) {
        return `/pid/${item.pid}`
      }
      return `/pid/${item.contentLink}`
    }

    return {
      BASE_URL,
      places,
      store,
      state,
      route,
      bookmarkItem,
      content: props.item.content,
      contentList,
      collections: false,
      displayTagList,
      indexHighlight: props.item.highlightFields,
      itemIndex: props.index + 1,
      placeholderType: store.getters.PlaceholderImageType,
      contentsName,
      tagList,
      onUnlink,
      notThumbnail,
      hasThumbnail,
      permissionColor,
      permissionText,
      thumbnailLink,
    }
  }
})
